var map = {
	"./aperture.svg": "71e2",
	"./camera.svg": "24e5",
	"./date.svg": "70f5",
	"./dimensions.svg": "2074",
	"./exposure.svg": "06ba",
	"./focal-length.svg": "44c3",
	"./iso.svg": "d092",
	"./lens.svg": "8f00",
	"./time.svg": "79aa"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6f32";